import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { DienstleistungService } from './dienstleistung.service';

export const dienstleistungResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot) => {
  const dienstleistungService = inject(DienstleistungService);
  const code: string = route.params['code'];
  return dienstleistungService.initDienstleistung(code);
};
